import "./footer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

export default function Footer() {


    return (
        <div className="footer" id="footer">
            <div className="contenedor">
                <img src="/assets/img/logo.png" alt="logo" className="logo" />
                <div className="info">
                    <h2>ENCONTRANOS EN:</h2>
                    <p><FontAwesomeIcon icon={faInstagram} /><a href="https://www.instagram.com/jyg.agrimensura/"> @jyg.agrimensura</a></p>
                    <p><FontAwesomeIcon icon={faLinkedin} /><a href="https://www.linkedin.com/company/jygagrimensura/posts/?feedView=all"> jygagrimensura</a></p>
                </div>
            </div>
            <p className="info2">
                Copyright © J&G AGRIMENSURA Y TOPOGRAFÍA<br />
                Todos los derechos reservados
            </p>
            <p className="info3">
                Desarrollado por <a href="https://gianfelice-portfolio.vercel.app/" target="_blank"> &lt;Gianfelice Juan/&gt;</a>
            </p>

        </div>

    );
}
